import { AppBar, Grid, Tab, Tabs } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { debounce } from "lodash";
import moment from "moment";
import NewTicket from "pages/agent-dashboard/NewTicket";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import socketIO from "socket.io-client";

import { getData, getLogs } from "../../api/apiCaller";
import datetimeHelper from "../../helper/datetime-helper";
import { mapActionsToProps as agentAction } from "../../redux/agent";
import { mapActionsToProps as outboundCallAction } from "../../redux/cloudPBX/outboundCall";
import { mapActionsToProps as articelAction } from "../../redux/miniCrm/article";
import { mapActionsToProps as commentAction } from "../../redux/miniCrm/comment";
import { mapActionsToProps as contactAction } from "../../redux/miniCrm/contact";
import { mapActionsToProps as indastryAction } from "../../redux/miniCrm/indastry";
import { mapActionsToProps as knowledgeBase } from "../../redux/miniCrm/knowledgeBase";
import { mapActionsToProps as stageAction } from "../../redux/miniCrm/stage";
import { mapActionsToProps as ticketAction } from "../../redux/miniCrm/ticket";
import { mapActionsToProps as InboundReport } from "../../redux/report/inbound";
import {
  mapActionsToProps as callLogsAction,
  mapActionsToProps,
} from "../../redux/telesale/call";
import AgentDashboardHeader from "./AgentDashboardHeader";
import {
  FONT_SIZE_DEFAULT,
  FONT_SIZE_SMALL,
  FONT_SIZE_TABLE,
  HEIGHT_RESIZE,
  WIDTH_RESIZE,
} from "./Constant";
import TicketHistory from "./TicketHistory";

const styles = (theme) => {
  return {
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      fontWeight: "bold",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    textTitle: {
      color: "#263238",
      fontWeight: 600,
      fontSize: FONT_SIZE_DEFAULT + 2,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        fontSize: FONT_SIZE_SMALL + 2,
      },
    },
    text: {
      color: "#263238",
      fontWeight: 400,
      fontSize: FONT_SIZE_DEFAULT - 2,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        fontSize: FONT_SIZE_SMALL - 2,
      },
    },
    textFieldInputRoot: {
      fontSize: FONT_SIZE_DEFAULT,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        fontSize: FONT_SIZE_SMALL,
        padding: "4px 1px 1px 3px",
      },
    },
    textFieldOutlinedInputRoot: {
      fontSize: FONT_SIZE_DEFAULT,
      padding: 15,
      minHeight: 0,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        padding: 10,
        fontSize: FONT_SIZE_SMALL,
      },
      [`@media (max-height:${HEIGHT_RESIZE}px)`]: {
        padding: 7,
      },
    },
    menuItem: {
      fontSize: FONT_SIZE_DEFAULT,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        padding: "7px 10px",
        fontSize: FONT_SIZE_SMALL,
      },
    },
    button: {
      height: 30,
      fontSize: FONT_SIZE_DEFAULT - 2,
      textTransform: "none",
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        height: 27,
        fontSize: FONT_SIZE_SMALL - 1,
      },
    },
    icon: {
      fontSize: 23,
      marginRight: 3,
      [theme.breakpoints.down(WIDTH_RESIZE)]: { fontSize: 18 },
    },
    iconFontAwesome: {
      fontSize: 18,
      marginRight: 3,
      [theme.breakpoints.down(WIDTH_RESIZE)]: { fontSize: 12 },
    },
    tabsRoot: {
      minHeight: 35,
      height: 35,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        minHeight: 24,
        height: 24,
      },
    },
    tabRoot: {
      minHeight: 35,
      height: 35,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        minHeight: 24,
        height: 24,
        minWidth: 120,
        width: 120,
      },
    },
    tabLabelContainer: {
      padding: "2px 5px",
    },
    tableCell: {
      fontSize: FONT_SIZE_TABLE,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        fontSize: FONT_SIZE_TABLE - 2,
      },
    },
    input: {
      width: "100%",
      color: "black",
    },
    inputSearch: {
      marginLeft: 8,
      flex: 1,
    },
    iconButtonSearch: {
      padding: 10,
    },
    active: {
      color: "#ffffff",
    },
    gridItemPaddingRight: {
      [theme.breakpoints.up("md")]: { paddingRight: "3px !important" },
    },
    gridItemPaddingLeft: {
      [theme.breakpoints.up("md")]: { paddingLeft: "3px !important" },
    },
  };
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

class AgentDashboard extends Component {
  constructor(props) {
    super(props);
    this.getByPhone = debounce(props.getInfoCustomerWithoutSocket, 500);
  }

  state = {
    status: {
      ...this.props.status,
    },
    statusId: "",
    value: "",
    question: [],
    questions: [],
    optionsDate: { id: "", text: new Date() },
    options: [],
    optionsText: [],
    optionsCheckBox: [],
    optionsMultiCheckBox: [],
    checkedOptions: [],
    optionsSelect: [{ id: "", text: "" }],
    open: false,
    top: false,
    content: "",
    note: null,
    idQuestion: "",
    tags: "",
    data: [],
    callback: false,
    timeCallBack: null,
    stageId: "",
    idTicket: "",
    ticket: {
      birthDay: null,
      dateRange: null,
      Status: "Đã tiếp nhận",
      Priority: "Trung bình",
    },
    demo: [],
    optionTicket: false,
    optionTicketView: false,
    idTicketView: "",
    dataTicketView: {},
    customer: {
      name: "",
      email: "",
      address: "",
    },
    editCustomer: true,
    editNoteCall: false,
    itemCall: null,
    indexCall: null,
    openModelEdit: false,
    viewTicket: {},
    item: null,
    nameTicket: "",
    district: [],
    ward: [],
    inputValue: "",
    itemSelect: [],
    accountName: "",
    posOfficeLead: [],
    posOffice: [],
    lead: {},
    Product_name: "",
    showRequire: false,
    Pos_Name: "",
    Owner_Name: "",
    type: "",
    listPhone: [],
    phoneTab: "",
    idTicketPhone: "",
    phoneSelected: null,
    idTicketCurrent: "",
    phoneItem: null,
    loadingBtn: false,
    servicesC: [],
    postTicket: {
      idPostOffice: "",
      postOfficeName: "",
      postalCode: "",
      province: "",
      otherPhone: "",
      otherNote: "",
      idHandlePeople: "",
      handlePeople: "",
    },
  };

  getListTickets() {
    return getLogs("/mini-crm/ticket?query=pending", {
      order: "createdAt DESC",
      limit: null,
      skip: null,
      where: {
        and: [
          { answeredAt: { lte: `${moment().format("YYYY-MM-DD")} 23:59:59` } },
          { answeredAt: { gte: `${moment().format("YYYY-MM-DD")} 00:00:00` } },
        ],
        source: { neq: "ott" },
      },
    });
  }

  async componentDidMount() {
    // TODO remove api not use, convert to hooks
    this.props.getListKnowledgeBase();
    await this.props.getListStage();
    await this.props.getStatusAgent();
    this.props.getListIndastry();
    this.props.getTicketType();
    this.props.getAgentReportWorking();
    this.props.getListReportInbound(
      `${datetimeHelper.toFormat(new Date(), "YYYY-MM-DD")}`,
      `${datetimeHelper.toFormat(new Date(), "YYYY-MM-DD")}`
    );
    this.interval = setInterval(() => {
      this.props.getListReportInbound(
        `${datetimeHelper.toFormat(new Date(), "YYYY-MM-DD")}`,
        `${datetimeHelper.toFormat(new Date(), "YYYY-MM-DD")}`
      );
      this.props.getAgentReportWorking();
    }, 30000);
    // this.props.getContactSF();
    // this.props.getEmployeeSF();
    // this.props.getPosSF();
    // this.props.getProductSF();
    // // this.props.getSaleOrderSF()
    // this.props.getPackageSF();
    // this.props.getServices();
    const ticketPhone = await this.getListTickets();
    this.setState(
      {
        listPhone: this.state.listPhone.concat(ticketPhone.data),
      },
      () => {
        // Trong trường hợp vào màn hình làm việc từ nơi khác
        if (
          this.props.listActiveCall &&
          this.props.listActiveCall[0] &&
          this.props.listActiveCall[0].status &&
          this.props.listActiveCall[0].status === "answering" &&
          this.state.phoneTab !== this.props.listActiveCall[0].from
        ) {
          this.setState(
            {
              idTicketPhone:
                this.state.listPhone.length > 0
                  ? this.state.listPhone[0].id
                  : "",
              phoneTab: this.props.listActiveCall[0].from,
              phoneSelected: this.props.listActiveCall[0],
            },
            () => {
              const { phoneTab } = this.state;
              this.props.getInfoCustomer(phoneTab);
              this.props.getTicketByNumber({
                phone: phoneTab,
                // source: { neq: "ott" },
              });
              this.props.getTodayMixCalls(phoneTab);
            }
          );
        } else {
          this.setState(
            {
              idTicketPhone:
                this.state.listPhone.length > 0
                  ? this.state.listPhone[0].id
                  : "",
              phoneTab:
                this.state.listPhone.length > 0
                  ? this.state.listPhone[0].phone
                  : "",
              phoneSelected: this.state.listPhone[0],
            },
            () => {
              const { phoneTab } = this.state;
              this.props.getInfoCustomer(phoneTab);
              this.props.getTicketByNumber({
                phone: phoneTab,
                // source: { neq: "ott" },
              });
              this.props.getTodayMixCalls(phoneTab);
            }
          );
        }
        // Trong trường hợp vào màn hình làm việc từ nơi khác
        let socket = undefined;
        socket = socketIO(
          `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_WS}.api-connect.io`,
          {
            query: {
              resource: "extension",
              extension:
                this.props.initStatus.agentStatus !== undefined &&
                this.props.initStatus.agentStatus.extension !== undefined
                  ? this.props.initStatus.agentStatus.extension.username
                  : "",
              // accessToken: this.props.initStatus.id,
            },
            transports: ["websocket", "polling"],
          }
        );

        socket.on("connect", function () {
          console.log(`Connected Agent User Socket. Socket Id: ${socket.id}`);
        });

        socket.on("connect_error", function (err) {
          console.log("Connect Agent User Socket Failed. " + err.message);
        });

        socket.on("createdTicket", (data) => {
          const listPhone = [...data, ...this.state.listPhone];
          this.setState(
            {
              listPhone,
            },
            () => {
              const phoneRinging =
                this.state.listPhone.length > 0 &&
                this.state.listPhone.find(
                  (v) =>
                    v.phone ===
                      (this.props.listActiveCall &&
                      this.props.listActiveCall.length
                        ? this.props.listActiveCall[0].from
                        : "false") || v.id === data[0].id
                );
              this.setState(
                {
                  idTicketPhone: phoneRinging ? phoneRinging.id : data[0].id,
                  phoneTab: phoneRinging ? phoneRinging.phone : data[0].phone,
                  phoneSelected: phoneRinging ? phoneRinging : data[0],
                },
                () => {
                  const { phoneTab } = this.state;
                  this.props.getInfoCustomer(phoneTab);
                  this.props.getTicketByNumber({
                    phone: phoneTab,
                    // source: { neq: "ott" },
                  });
                  this.props.getTodayMixCalls(phoneTab);
                }
              );
            }
          );
        });
        socket.on("disconnect", () => {
          this.setState({
            listPhone: [],
          });
        });
      }
    );
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTicket = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const { ticket } = this.state;
    ticket[name] = e.target.value ? e.target.value : "";
    // let tinh = []
    // let ward = []

    this.setState(
      {
        ticket,
      },
      async () => {
        if (name === "SuppliedPhone") {
          const info = await getData("/mini-crm/contact/get-contact-by-phone", {
            phone: this.state.ticket.SuppliedPhone,
          });

          const { agentStatus } = this.props;
          this.setState({
            ticket: {
              ...this.state.ticket,
              // SuppliedPhone: info.data && info.data.phone ? info.data.phone : '',
              SuppliedName: info.data && info.data.name ? info.data.name : "",
            },
            Employee_Name:
              agentStatus &&
              agentStatus.attributes &&
              agentStatus.attributes.Employee &&
              agentStatus.attributes.Employee.name
                ? agentStatus.attributes.Employee.name
                : "",
            accountName:
              info.data && info.data.accountName ? info.data.accountName : "",
          });
        }
      }
    );
  };

  handleAddNote = () => {
    if (this.state.itemCall != null) {
      this.props.addNoteCall(
        this.state.itemCall.note,
        this.state.itemCall.id,
        "",
        this.state.itemCall.type
      );
      this.setState({ openModelEdit: !this.state.openModelEdit });
    } else {
      this.props.addNoteCall(this.state.note, "", "", this.state.itemCall.type);
      this.setState({ openModelEdit: !this.state.openModelEdit });
    }
  };

  handleOpenEditNote = (item) => {
    this.setState(
      { itemCall: item, openModelEdit: !this.state.openModelEdit },
      () => {
        this.setState({ note: item.note });
      }
    );
  };

  handleChangeTab = (e, idTicketPhone) => {
    const { listPhone } = this.state;
    const phone =
      listPhone.length > 0
        ? listPhone.find((val) => val.id === idTicketPhone).phone
        : "";

    this.setState(
      {
        idTicketPhone,
        phoneTab: phone,
        phoneSelected: listPhone.find((val) => val.id === idTicketPhone),
      },
      () => {
        this.props.getInfoCustomer(phone);
        this.props.getTicketByNumber({
          phone,
          // source: { neq: "ott" }
        });
        this.props.getTodayMixCalls(phone);
      }
    );
  };

  render() {
    const {
      classes,
      working,
      logInboundOutbound,
      getTicket,
      agentReport,
      reportInbound,
    } = this.props;

    const { listPhone } = this.state;

    return (
      <React.Fragment>
        <Paper elevation={1} style={{ marginBottom: 5, padding: 3 }}>
          <AgentDashboardHeader
            agentReport={agentReport}
            reportInbound={reportInbound}
            styles={classes}
          />
        </Paper>
        {listPhone.length > 0 && (
          <AppBar position="static" style={{ marginBottom: "5px" }}>
            <Tabs
              value={this.state.idTicketPhone || listPhone?.[0].id || ""}
              onChange={this.handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              TabIndicatorProps={{ style: { background: "#015290" } }}
              classes={{ root: classes.tabsRoot }}>
              {listPhone?.slice(0, 20).map((item, index) => {
                return (
                  <Tab
                    key={item?.id}
                    label={
                      <span
                        className={classes.textTitle}
                        style={{ color: "#303030" }}>
                        {item?.phone}
                        {item?.refId === "pending" && (
                          <i
                            className={`fas fa-exclamation ${classes.iconFontAwesome}`}
                            style={{
                              marginLeft: 5,
                              marginRight: 0,
                              color: "red",
                            }}
                          />
                        )}
                      </span>
                    }
                    value={item?.id}
                    classes={{
                      root: classes.tabRoot,
                      labelContainer: classes.tabLabelContainer,
                    }}
                    className={
                      item?.id === this.state.idTicketPhone
                        ? classes.active
                        : ""
                    }
                    {...a11yProps(index)}
                    style={{ fontSize: 20 }}
                  />
                );
              })}
            </Tabs>
          </AppBar>
        )}
        <Grid container spacing={24}>
          <Grid
            className={classes.gridItemPaddingRight}
            item
            lg={7}
            md={6}
            xs={12}>
            <Paper
              className={classes.root}
              elevation={1}
              style={{
                maxHeight: "75vh",
                overflow: "auto",
                position: "relative",
              }}>
              <TicketHistory
                styles={classes}
                isLoading={this.props.loadingTicket}
                ticketHistory={getTicket}
                phoneSelected={this.state.phoneSelected}
              />
            </Paper>
          </Grid>
          <Grid
            className={classes.gridItemPaddingLeft}
            item
            lg={5}
            md={6}
            xs={12}>
            <Paper className={classes.root} elevation={1}>
              <NewTicket
                onRefreshListPhone={async (idTicketPhone, phoneTab) => {
                  if (this.state.idTicketPhone === idTicketPhone) {
                    this.props.getTicketByNumber({
                      phone: phoneTab,
                      // source: { neq: "ott" },
                    });
                  }
                  const ticketPhone = await this.getListTickets();
                  this.setState({
                    listPhone: ticketPhone.data,
                    idTicketPhone: ticketPhone.data[0].id,
                    phoneSelected: ticketPhone.data[0],
                  });
                }}
                idTicketPhone={this.state.idTicketPhone}
                phoneTab={this.state.phoneTab}
                styles={classes}
                widthResize={WIDTH_RESIZE}
              />
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

AgentDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listCampaign: state.campaign.campaignConfig,
  listKnowledgeBase: state.knowledgeBase.knowledgeBases,
  listComment: state.comment.comment,
  working: state.agent.working,
  article: state.article.article,
  listStage: state.stage.stages,
  agentStatus: state.agent.status,
  listIndastry: state.indastry.indastries,
  loading: state.ticket.loading,
  contact: state.ticket.contact,
  employee: state.ticket.employee,
  pos: state.ticket.pos,
  product: state.ticket.product,
  saleOrder: state.ticket.saleOrder,
  package: state.ticket.package,
  logInboundOutbound: state.call.logInboundOutbound,
  loadingLog: state.call.loadingLog,
  infoCustomer: state.call.infoCustomer,
  loadingInfo: state.call.loadingInfo,
  infoCustomerWithoutSocket: state.call.infoCustomerWithoutSocket,
  getTicket: state.call.getTicket,
  loadingTicket: state.call.loadingTicket,
  agentReport: state.call.agentReport,
  posOffice: state.call.posOffice,
  accountId: state.call.accountId,
  services: state.call.services,
  lead: state.call.lead,
  phoneSocket: state.call.phoneSocket,
  isLoading: state.call.isLoading,
  leadLoading: state.call.leadLoading,
  callStatus: state.call.callStatus,
  postOfficeLoading: state.call.postOfficeLoading,
  handlePeopleLoading: state.call.handlePeopleLoading,
  postOffice: state.call.postOffice,
  handlePeople: state.call.handlePeople,
  countByPhone: state.ticket.countByPhone,
  listActiveCall: state.channel.activeCall,
  initStatus: state.auth.init,
  reportInbound: state.reportInbound.report,
});
const AgentAction = connect(null, agentAction)(AgentDashboard);
const CommentAction = connect(null, commentAction)(AgentAction);
const KnowledgeBase = connect(null, knowledgeBase)(CommentAction);
const Article = connect(null, articelAction)(KnowledgeBase);
const CallLogs = connect(null, callLogsAction)(Article);
const OutBound = connect(null, outboundCallAction)(CallLogs);
const InboundReportAction = connect(null, InboundReport)(OutBound);
const Stage = connect(null, stageAction)(InboundReportAction);
const Indastry = connect(null, indastryAction)(Stage);
const Contact = connect(null, contactAction)(Indastry);
const Ticket = connect(null, ticketAction)(Contact);
AgentDashboard = connect(mapStateToProps, mapActionsToProps)(Ticket);

export default withStyles(styles)(AgentDashboard);
